import React from 'react';
import LogoUpload from '../LogoUpload/LogoUpload';

const FooterUpload = () => {
    return <LogoUpload type="footer" />;
};

export default FooterUpload;